<template>
  <div class="vue-dropzone-stub">
    <input type="file" :multiple="multiple" @change="onChange" />
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VueDropzone',
  props: {
    options: { type: Object, default: () => ({}) },
    id: { type: String, default: '' }
  },
  emits: ['vdropzone-success', 'vdropzone-error', 'vdropzone-file-added'],
  computed: {
    multiple () {
      return this.options?.maxFiles !== 1
    }
  },
  methods: {
    onChange (event) {
      const files = Array.from(event.target.files || [])
      files.forEach((file) => this.$emit('vdropzone-file-added', file))
    }
  }
}
</script>
